var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"Icon3dLink"},[_c('img',{staticClass:"icon icon3d",class:{
      'is-set-icon': _vm.isSetIcon,
      'number-items-4': _vm.isNumberItems4,
      'is-overview': _vm.isOverview,
      'is-addon-list': _vm.isAddonList,
      'mode-conf': _vm.visualMode === 'conf',
      'no-conf-mode': _vm.visualMode !== 'conf',
    },attrs:{"src":_vm.appUrl + '/img/icons/3d-icon.svg',"alt":"3D","title":"3D View"},on:{"click":function($event){return _vm.show()}}}),_c('label')])
}
var staticRenderFns = []

export { render, staticRenderFns }